/** A list of helpful regular expressions to keep validation consistent throughout the site. */
export class RegexUS {
  /** Validates an email address. */
  //prettier-ignore
  static email = new RegExp(
    '^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
  );

  /** Validates a post code */
  static postCode = new RegExp('^\\d{5}$');

  /** Validates a gender input field. */
  static gender = new RegExp('^(M|F|O)$');

  /** Validates a number input field */
  static number = new RegExp('^\\d+$');

  /** Validates currency for transfers */
  static currency = new RegExp('^[0-9]+(.[0-9]{1,2})?$');
}

export class RegexUK {
  /** Validates an email address. */
  //prettier-ignore
  static email = new RegExp(
    '^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
  );

  /** Validates a post code */
  static postCode = new RegExp('[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}');

  /** Validates a gender input field. */
  static gender = new RegExp('^(M|F|O)$');

  /** Validates a number input field */
  static number = new RegExp('^\\d+$');

  /** Validates currency for transfers */
  static currency = new RegExp('^[0-9]+(.[0-9]{1,2})?$');
}
